import type { DateQuery, RouterProps } from '../../common/helpers/types.tsx';
import { DEFAULT_OPTIONS, CUSTOM_TIMESCALE_ID } from './constants';
import { getAvailableOptionsByDateRange } from './date-picker-group/utils.tsx';
import type { DropdownOption, LastSearchQuery } from './types';

export const getTimeScaleId = ({ timescaleId }: RouterProps, defaultTimescaleId?: number) =>
	Number(timescaleId) || Number(defaultTimescaleId) || DEFAULT_OPTIONS.timescaleId;

export const mapToDateQuery = (
	routerProps: RouterProps,
	lastSearchQuery: LastSearchQuery,
): DateQuery => {
	if (Number(routerProps.timescaleId) === CUSTOM_TIMESCALE_ID && lastSearchQuery) {
		const startDate =
			routerProps.startDate !== undefined && routerProps.startDate !== ''
				? routerProps.startDate
				: lastSearchQuery.startDate;

		const endDate =
			routerProps.endDate !== undefined && routerProps.endDate !== ''
				? routerProps.endDate
				: lastSearchQuery.endDate;

		let { timeBreakdown } = routerProps;

		if (!timeBreakdown) {
			timeBreakdown = getAvailableOptionsByDateRange({ startDate, endDate }).defaultOption;
		}

		return {
			timescaleId: CUSTOM_TIMESCALE_ID,
			startDate,
			endDate,
			timeBreakdown,
		};
	}

	return {
		timescaleId: getTimeScaleId(routerProps),
	};
};

export const getSelectedOptionByRouterProps = (
	options: DropdownOption[],
	routerProps: RouterProps,
	defaultTimescaleId?: number,
): DropdownOption => {
	const timescaleId = getTimeScaleId(routerProps, defaultTimescaleId);
	const idx = options.findIndex((option) => option.id === timescaleId);
	return options[idx];
};
